import {ToastManagerBlock} from "./lib/ToastManagerBlock";

export const tags = {
    "toast-manager": ToastManagerBlock
};

export const lazyChunks = {
//    "toast-manager": somehowImportedChunksModule
};
